import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsCustomAttributeSchemaCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/custom_attributes_data",
];
